module.exports = "/images/322380d07269de5f87abe9efc6bc8bfa.png";